import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Agile(props) {
  return (
    <div className="tekrevol_gray_bg p-100">
      <Container classNanme="h-100">
        <Row classNanme="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <div className="example" data-text="Tech Leaders">
              <h2>Benefits of Choosing Managed Cloud Services</h2>
            </div>
            <p>
              As a leading cloud-managed services provider, we offer tons of
              benefits to businesses seeking to utilize cloud-managed services.
              We implement a modernized methodology while managing, monitoring,
              optimizing, and adapting your cloud operations. We align your
              cloud operations with your business objectives to determine your
              ability to innovate and how you can meet your expected business
              outcomes.
            </p>
            <p>
              We have completed multiple unique projects and helped several
              businesses adapt to the cloud approach, which is now progressing
              towards better times and revenue figures.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="agile_title my-auto offset-xl-1"
          >
            <div className="content_pointer">
              <div className="pointers_item">
                <div className="title_count">
                  56+<span>Projects Completed</span>
                </div>
              </div>
              <div className="pointers_item">
                <div className="title_count">
                  23+<span>Businesses Served</span>
                </div>
              </div>
              <div className="pointers_item">
                <div className="title_count">
                  08+<span>Industries Served</span>
                </div>
              </div>
            </div>
            <StaticImage
              src="../../images/services/managed-clouds/benefits.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Agile;
